import React from "react";
import { Image } from "@chakra-ui/react";

/**
 * ActivityStateButton - Reusable component for activity state buttons
 * @param {string} src - Source path for the SVG icon
 * @param {object} props - Additional props to pass to Image component
 */
const ActivityStateButton = ({ src, ...props }) => {
  return <Image src={src} w={6} h={6} {...props} />;
};

export default ActivityStateButton;
